import React from 'react';
import { Provider as ReduxProvider } from 'react-redux';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { ReactQueryDevtools } from '@tanstack/react-query-devtools';

import store from './store';
import Router from './Router';
import errorFallbackRender from './ErrorFallbackRender';
import { ErrorBoundary } from 'react-error-boundary';
import { getDatadogLogger } from '@storebrand-digital/common-datadog';
import { useKron } from './hooks/useKron';
import { useInsetCssVariables } from './hooks/useInsetCssVariables';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      let errorMessage: string;
      if (query.meta && query.meta.datadogErrorMessage) {
        errorMessage = query.meta.datadogErrorMessage as string;
      } else {
        errorMessage = 'Failed to run query';
      }
      getDatadogLogger().error(errorMessage, {}, error);
    },
  }),
});

function App() {
  const { insets } = useKron();
  useInsetCssVariables(insets);
  return (
    <ErrorBoundary
      fallbackRender={errorFallbackRender}
      onError={(err) => getDatadogLogger().error(err.message, {}, err)}
    >
      <QueryClientProvider client={queryClient}>
        <ReactQueryDevtools />
        <ReduxProvider store={store}>
          <Router />
        </ReduxProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
